import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight
import {
    PhoneIphone,
    PhoneAndroid,
    Face6,
    Password,
    Visibility,
    VisibilityOff,
    Smartphone
} from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const RegisterPhone = () => {
    const [name, setName] = useState("");
    const [identifier, setIdentifier] = useState("");
    const [type, setType] = useState("");
    const [password, setPassword] = useState("");
    const [cnpassword, setCnPassword] = useState("");
    const [posting, setPosting] = useState(false);
    const [paswdOpen, setPwsdOpen] = useState(false);
    const [paswdCnOpen, setPwsdCnOpen] = useState(false);
    const navigate = useNavigate();

    const handleProceed = async () => {
        if (identifier === "") {
            toast.warn("Failed. Fill in your phone number", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (name === "") {
            toast.warn("Failed. Fill in your name", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (password === "") {
            toast.warn("Failed. Fill in your password", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (password !== cnpassword) {
            toast.warn("Failed. Password is not confirmed correctly", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }

        setPosting(true);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+/;
        const phoneRegexLocal = /^07/; // e.g.,0 7 7 3 2 2 8 8 2 9
        const phoneRegexIntl = /^2637/; // e.g.,2 6 3 7 7 3 2 2 8 8 2 9

        if (phoneRegexLocal.test(identifier)) {
            if (identifier.length != 10) {
                toast.warn("Failed. Please provide a valid phone number length", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return;
            }
        } else if (phoneRegexIntl.test(identifier)) {
            if (identifier.length != 12) {
                toast.warn("Failed. Please provide a valid phone number length", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return;
            }
        } else {
            toast.warn("Failed. Please provide a valid phone number length", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }

        const dataObj = {
            name,
            identifier,
            type,
            password,
        }

        console.log(dataObj);
        //Today
        const baseUrl = apilink.link;
        await axios
            .post(`${baseUrl}/auth/register`, dataObj, {
                headers: {
                    "Content-Type": "application/json",
                },
            })

            .then((response) => {
                setPosting(false);
                if (response.data.message = "Registered successfully. OTP sent.") {
                    // toast.success("Registration successfull. OTP sent", {
                    //     position: "top-center",
                    //     autoClose: 5000,
                    //     hideProgressBar: false,
                    //     closeOnClick: false,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     progress: undefined,
                    //     theme: "light",
                    // });
                    const regData = {
                        "identifier": identifier,
                        "id_type": "phone"
                    }

                    localStorage.setItem("userReg", JSON.stringify(regData));
                    navigate("/otp");
                }
            })
            .catch((error) => {
                setPosting(false);
                console.log(error);
                console.log(error.response.data.message);
            });
    };

    const handleMemberSignIn = () => {
        navigate("/");
    };

    useEffect(() => {
        const getAsyncData = async () => {
            const regData = await JSON.parse(
                localStorage.getItem("userReg")
            );
            console.log("code: " + regData.identifier);
            setIdentifier(regData.identifier);
            setType(regData.id_type);
        };
        getAsyncData();
    }, []);

    return (
        <>
            <div
                style={{
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "56px",
                    paddingInline: 30,
                }}
            >
                <img
                    alt="logo"
                    style={{ width: "100px", height: "80px", resizeMode: "stretch" }}
                    src={require("./logo.png")}
                />
                <h1
                    className="navbar-brand mb-0"
                    style={{ fontFamily: "Caveat", fontSize: 38 }}
                >
                    <b>Collide - </b> Dating
                </h1>
                <p
                    style={{
                        color: "#010832",
                        fontFamily: "Open Sans",
                        marginTop: "30px",
                    }}
                >
                    Phone Registration
                </p>
                <p
                    style={{
                        color: "#00000090",
                        fontFamily: "Open Sans",
                        marginTop: "10px",
                        fontSize: "12px"
                    }}
                >
                    <center>
                        Fill in your details below. You will receive a one-time <br />confirmation code (OTP) on your phone to<br /> proceed to the next step
                    </center>
                </p>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <PhoneAndroid style={{ color: "#ffffff", marginTop: '15px' }} />
                        <p style={{ color: '#ffffff', fontSize: '8pt' }}>Phone</p>
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <input
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',

                            }}
                            value={identifier}
                            placeholder=""
                            onChange={(e) => { setIdentifier(e.target.value) }}
                        />
                    </div>
                    <div></div>
                </div>
                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Face6 style={{ color: "#ffffff", marginTop: '15px' }} />
                        <p style={{ color: '#ffffff', fontSize: '8pt' }}>Name</p>
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <input
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',

                            }}
                            value={name}
                            placeholder="Full name . . ."
                            onChange={(e) => { setName(e.target.value) }}
                        />
                    </div>
                    <div></div>
                </div>
                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Password style={{ color: "#ffffff", marginTop: '15px' }} />
                        <p style={{ color: '#ffffff', fontSize: '8pt' }}>Password</p>
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "220px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <input
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                // borderTopRightRadius: 5,
                                // borderBottomRightRadius: 5,
                                outlineStyle: 'none',

                            }}
                            value={password}
                            type={paswdOpen ? "text" : "password"}
                            placeholder="Password . . ."
                            onChange={(e) => { setPassword(e.target.value) }}
                        />
                    </div>
                    <div style={{
                        width: "40px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#ffffff",
                        borderRight: "1px solid #010832",
                        borderTop: "1px solid #010832",
                        borderBottom: "1px solid #010832",
                        borderBottomRightRadius: "5px",
                        borderTopRightRadius: "5px",
                    }}>
                        {paswdOpen ? <>
                            <Visibility onClick={() => { setPwsdOpen(!paswdOpen) }} style={{ color: "#5f5b5b" }} />
                        </> : <>
                            <VisibilityOff onClick={() => { setPwsdOpen(!paswdOpen) }} style={{ color: "#5f5b5b" }} />
                        </>}
                    </div>
                    <div></div>
                </div>
                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Password style={{ color: "#ffffff", marginTop: '15px' }} />
                        <p style={{ color: '#ffffff', fontSize: '8pt' }}>Confirm</p>
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "220px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <input
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                // borderTopRightRadius: 5,
                                // borderBottomRightRadius: 5,
                                outlineStyle: 'none',

                            }}
                            value={cnpassword}
                            type={paswdCnOpen ? "text" : "password"}
                            placeholder="Confirm password . . ."
                            onChange={(e) => { setCnPassword(e.target.value) }}
                        />
                    </div>
                    <div style={{
                        width: "40px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#ffffff",
                        borderRight: "1px solid #010832",
                        borderTop: "1px solid #010832",
                        borderBottom: "1px solid #010832",
                        borderBottomRightRadius: "5px",
                        borderTopRightRadius: "5px",
                    }}>
                        {paswdCnOpen ? <>
                            <Visibility onClick={() => { setPwsdCnOpen(!paswdCnOpen) }} style={{ color: "#5f5b5b" }} />
                        </> : <>
                            <VisibilityOff onClick={() => { setPwsdCnOpen(!paswdCnOpen) }} style={{ color: "#5f5b5b" }} />
                        </>}
                    </div>
                    <div></div>
                </div>

                <button
                    onClick={() => handleProceed()}
                    style={{
                        width: "320px",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        border: "none",
                        height: 50,
                        fontFamily: "Open Sans",
                        fontSize: 14,
                        color: "white",
                        marginTop: "10px",
                    }}
                >
                    {posting === false && <>Register</>}
                    {posting && (
                        <>
                            <Squares />
                        </>
                    )}
                </button>


                <p
                    onClick={() => handleMemberSignIn()}
                    style={{
                        color: "#000000",
                        fontFamily: "Open Sans",
                        fontSize: 14,
                        marginTop: "20px",
                        alignSelf: "left",
                        width: "320px",
                    }}
                >
                    Already registered &nbsp;?&nbsp; <span style={{ color: "#010832" }}>Click here to login</span>
                </p>

                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </div>
        </>
    );
};

export default RegisterPhone;
